/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostinghelpfixtitle3Inputs */

const en_crosspostinghelpfixtitle3 = /** @type {(inputs: Crosspostinghelpfixtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connecting fails (e.g. "not enough permissions")?`)
};

const de_crosspostinghelpfixtitle3 = /** @type {(inputs: Crosspostinghelpfixtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbinden schlägt fehl (z. B. „nicht genug Berechtigungen“)?`)
};

/**
* | output |
* | --- |
* | "Connecting fails (e.g. \"not enough permissions\")?" |
*
* @param {Crosspostinghelpfixtitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostinghelpfixtitle3 = /** @type {((inputs?: Crosspostinghelpfixtitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostinghelpfixtitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostinghelpfixtitle3(inputs)
	return de_crosspostinghelpfixtitle3(inputs)
});
export { crosspostinghelpfixtitle3 as "crosspostingHelpFixTitle" }